import { PlanExtraDetail } from '@dtx-company/true-common/src/types/Plan'

export interface UpgradeSubscriptionPlanExtra {
  planExtraId: string
  quantity: number
}

export const convertExtraDetailsToUpgradeExtraDetails = (
  data?: PlanExtraDetail[]
): UpgradeSubscriptionPlanExtra[] | undefined =>
  data
    ? data.map(detail => ({
        planExtraId: detail.planExtraId,
        quantity: detail.quantity
      }))
    : undefined
